module.exports = __webpack_public_path__ + "app/images/icons/headline1.svg";